import styled from "styled-components";

export const UnstyledButton = styled.button<{ disabled?: boolean }>`
  cursor: pointer;
  width: 100%;
  margin: 0 0 16px 0;
  border-radius: 10px;
  padding: 20px 20px 10px 20px;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1);
  color: #333;
  transition: box-shadow 0.25s;
  ${({ disabled }) =>
    disabled
      ? `
  border: 1px solid #e0e3e6;
  background: #e0e3e6;
  pointer-events: none;
  `
      : `
  background: white;
  border: 1px solid rgba(51, 51, 51, 0.15);
  cursor: pointer;
      `}

  &:hover {
    box-shadow: 1px 3px 6px -1px rgba(0, 0, 0, 0.15);
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 72px;
`;

export const BlockContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`;

export const Title = styled.h3`
  font-size: 22px;
  margin-bottom: 0;
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 300;
`;

export const IconContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: end;
  font-size: 32px;
`;
